import React from "react"

import PressRelease2025 from "./templates/pressRelease2025"
import PressRelease2024 from "./templates/pressRelease2024"

const SectionBody = ({ year }) => {
  return <>{year === "2025" ? <PressRelease2025 /> : <PressRelease2024 />}</>
}

export default SectionBody
